import { first, last } from 'lodash';

import { getModelOrThrow, getModelRelationOrThrow } from '@/explore/model/utils';
import { JoinStrategySteps, Model, PipelineStateRelation, Relation } from '@/explore/types';

export const getRelation = (
  relations: PipelineStateRelation[],
  key: string,
  baseModelId?: string,
) => {
  return relations.find(
    (relation) =>
      relation.key === key && (baseModelId === undefined || relation.baseModelId === baseModelId),
  );
};

export const getValidRelationTypesForOperation = (
  operation: 'relationAggregate' | 'addRelatedColumn' | undefined,
) => {
  switch (operation) {
    case 'relationAggregate':
      return ['hasMany', 'manyToMany'];
    case 'addRelatedColumn':
      return ['hasOne', 'hasOneThrough'];
    default:
      return ['hasMany', 'manyToMany', 'hasOne', 'hasOneThrough'];
  }
};

export const getThroughRelations = (
  joinStrategy: JoinStrategySteps,
  models: Model[],
  relations: Relation[],
) => {
  const firstRelation = relations.find((r) => r.key === first(joinStrategy.steps)?.relationKey);
  if (firstRelation === undefined) {
    return [];
  }
  return joinStrategy.steps.slice(1).reduce(
    (acc, step) => {
      const model = getModelOrThrow(models, last(acc)?.modelId ?? '');
      const relation = getModelRelationOrThrow(step.relationKey, model);
      return [...acc, relation];
    },
    [firstRelation],
  );
};
